<dialog-header [dialogRef]="dialogRef" headerKey="TASKS.SET_ASSIGNEE"></dialog-header>
<div mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-form-field>
      <mat-label>{{ 'TASKS.SET_ASSIGNEE' | translate }}</mat-label>
      <mat-select formControlName="user" [multiple]="false">
        <mat-option *ngFor="let user of data.users" [value]="user.id">
          {{ getUserLabel(user) }}
        </mat-option>
      </mat-select>
      <mat-error>{{ 'FIELD_ERROR.ASSIGNEE' | translate }}</mat-error>
    </mat-form-field>
    <dialog-buttons submitLabel="SAVE"></dialog-buttons>
  </form>
</div>


